import { z } from 'zod';
const tier = z.object({
    cartValueStart: z
        .number()
        .nonnegative('Cart value start must be non-negative'),
    cartValueEnd: z.number().positive('Cart value end must be greater than 0'),
    chargePercentage: z
        .number()
        .min(0, 'Charge percentage must be between 0 and 100')
        .max(100, 'Charge percentage must be between 0 and 100'),
    unitInterval: z.union([
        z.literal(25),
        z.literal(50),
        z.literal(100),
        z.literal(200),
        z.literal(250),
    ]),
});
const createShipProtectSet = z.object({
    name: z.string().min(1, 'Ship protect set name is required'),
    displayName: z.string().optional(),
    tiers: z.array(tier).min(1, 'At least one tier is required'),
});
const shipProtectSet = z.object({
    id: z.number(),
    name: z.string(),
    displayName: z.string().nullable(),
    code: z.string().nullable(),
    description: z.string().nullable(),
    createdOn: z.string(),
    updatedOn: z.string().nullable(),
    storeCount: z.number(),
});
const unit = z.object({
    id: z.number(),
    rangeStart: z.number(),
    rangeEnd: z.number(),
    chargeAmount: z.number(),
    billMerchantAmount: z.number(),
    sku: z.string().nullable(),
});
const unitInput = z.object({
    chargeAmount: z.number().nonnegative('Charge amount must be non-negative'),
    rangeStart: z.number().nonnegative('Range start must be non-negative'),
    rangeEnd: z.number().positive('Range end must be greater than 0'),
    billMerchantAmount: z
        .number()
        .nonnegative('Bill merchant amount must be non-negative')
        .optional(),
});
const shipProtectSetDetail = shipProtectSet.extend({
    units: z.array(unit),
});
export const commandShipProtectSet = {
    base: shipProtectSet,
    create: createShipProtectSet,
    baseUnit: unit,
    unitInput,
    detail: shipProtectSetDetail,
};
//# sourceMappingURL=protectSet.js.map